import { Navigate, useParams } from 'react-router';
import { BoardLayout } from '../planner/board/BoardLayout';
import { currentWeek, parseIsoWeek } from '../planner/weekMath';

/** The week on the smartboard. */
export default function DigibordPage() {
  const target = parseIsoWeek(useParams());
  if (!target) {
    const now = currentWeek();
    return <Navigate to={`/week/${now.year}/${now.week}/digibord`} replace />;
  }
  return <BoardLayout key={`${target.year}-${target.week}`} target={target} backHref={`/week/${target.year}/${target.week}`} />;
}
